// This file is the entry point for the Vue.js Agatrs client application.
/***************************************************************************************/
/* It initializes the Vue instance, sets up plugins, and mounts the main App component.
/***************************************************************************************/

import Vue from "vue";
Vue.config.devtools = true;

import App from "./App.vue";
import store from "./store/store.js"; // This injects store.js into all components so that they have direct access to it.
import router from "./routes/router.js";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import RouterPrefetch from "vue-router-prefetch";
import DashboardPlugin from "./plugins/dashboard-plugin"; // Custom plugin for dashboard functionality based on Vue Black Dashboard PRO - v1.2.1
import axios from "@/axios";
import VueAxios from "vue-axios";
import VueSignaturePad from "vue-signature-pad";
import vSelect from "vue-select";
import { DatePicker } from "element-ui";
import Toast from "vue-toastification";
import VTooltip from "v-tooltip";
import IdleVue from "idle-vue";

// Import CSS
import "vue-select/dist/vue-select.css";
import "vue-toastification/dist/index.css";

import "../public/AGATRS.css";
import "../public/508-Compliance.css";

import i18n from "./i18n";
import format from "element-ui/lib/locale/format";

// Plugin Setup (Registers the plugins globally)
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Toast, {
  filterBeforeCreate: (toast, toasts) => {
    // Prevent duplicate toasts with same content and type
    const isDuplicate = toasts.some(
      t => t.content === toast.content && t.type === toast.type
    );
    
    if (isDuplicate) {
      return false; // Block creation
    }
    return toast; // Allow creation
  }
});
Vue.use(VTooltip);
Vue.use(VueSignaturePad);
Vue.use(DashboardPlugin);
Vue.use(RouterPrefetch);
Vue.component("v-select", vSelect);
Vue.use(DatePicker);

const eventsHub = new Vue();
const totalSessionDurationMinutes = process.env.VUE_APP_SESSION_TIMEOUT_MINUTES; // must match the value in SessionTimeOutModalManager.vue 
const idleVueTriggerTimeMs = (totalSessionDurationMinutes / 2) * 60 * 1000;

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store, // This is the Vuex store instance, which IdleVue will use to manage state
  idleTime: idleVueTriggerTimeMs, // This is key: triggers 'isIdle' after half the total session time
  startAtIdle: false,
  events: ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'] // Added 'scroll' to the default events
});
//GLOBAL
Vue.$router = router;

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: (h) => h(App),
});